import React, { FC, useEffect, useState } from 'react';

interface Props {
  customMessage?: string;
  imageSrc?: string;
}

export const EmptyPlaceholder: FC<Props> = ({
  customMessage = 'Oops!',
  imageSrc,
}) => {
  const [screenHeight, setScreenHeight] = useState(500); // Default value

  useEffect(() => {
    const handleResize = () => {
      // Subtracting 272 to account for any headers/footers or other offsets
      setScreenHeight(window.innerHeight - 272);
    };

    // Set initial height once on mount
    handleResize();

    // If you'd like the component to update on window resize
    window.addEventListener('resize', handleResize);

    // Cleanup the listener on unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div
      className="flex flex-col items-center justify-center p-4 bg-white rounded-2xl text-neutral-30 "
      style={{ height: screenHeight }}
    >
      <div className="max-w-[262px] flex flex-col items-center justify-center ">
        {imageSrc ? (
          <img
            src={imageSrc}
            alt="Placeholder Logo"
            className="object-contain mb-4 w-[130px]"
          />
        ) : null}

        <p className="text-center line-clamp-3">
          {customMessage && customMessage.trim()
            ? customMessage
            : 'Une erreur est survenu'}
        </p>
      </div>
    </div>
  );
};

export default EmptyPlaceholder;
